import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { CommitteeSection } from './components/CommitteeSection';
import { MatricesSection } from './components/MatricesSection';
import { AdvisorsSection } from './components/AdvisorsSection';
import { RegistrationSection } from './components/RegistrationSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';

export const App: React.FC = () => {
  // Check system prefers-reduced-motion
  const [reducedMotion, setReducedMotion] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    return false;
  });

  const [preselectedCommittee, setPreselectedCommittee] = useState<string>('');

  const toggleReducedMotion = () => {
    setReducedMotion(prev => !prev);
  };

  const handlePreselectCommittee = (committeeAbbr: string) => {
    setPreselectedCommittee(committeeAbbr);
    const regEl = document.getElementById('registration');
    if (regEl) {
      regEl.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  };

  const handleScrollToCommittees = () => {
    const el = document.getElementById('committees');
    if (el) {
      el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  };

  const handleScrollToRegistration = () => {
    const el = document.getElementById('registration');
    if (el) {
      el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  };

  return (
    <div className={`min-h-screen bg-deepblack text-ivory selection:bg-bronze selection:text-deepblack ${
      reducedMotion ? 'reduced-motion' : ''
    }`}>
      {/* Navigation */}
      <Navbar
        reducedMotion={reducedMotion}
        onToggleReducedMotion={toggleReducedMotion}
      />

      <main className="w-full">
        {/* Fullscreen Greek Architectural Hero */}
        <Hero
          reducedMotion={reducedMotion}
          onExploreCommittees={handleScrollToCommittees}
          onRegisterNow={handleScrollToRegistration}
        />

        {/* About Section */}
        <AboutSection reducedMotion={reducedMotion} />

        {/* 9 Committees Section */}
        <CommitteeSection
          reducedMotion={reducedMotion}
          onSelectCommitteeForRegistration={handlePreselectCommittee}
        />

        {/* Matrices & Official Portfolios Matrix */}
        <MatricesSection
          reducedMotion={reducedMotion}
          onSelectCommitteeForRegistration={handlePreselectCommittee}
        />

        {/* Meet Our Advisors Section */}
        <AdvisorsSection
          reducedMotion={reducedMotion}
        />

        {/* Registration Section with 2 Tracks */}
        <RegistrationSection
          reducedMotion={reducedMotion}
          preselectedCommittee={preselectedCommittee}
        />

        {/* Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer
        reducedMotion={reducedMotion}
      />
    </div>
  );
};

export default App;
